/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardAgentState } from './DashboardAgentState';
import {
    DashboardAgentStateFromJSON,
    DashboardAgentStateFromJSONTyped,
    DashboardAgentStateToJSON,
    DashboardAgentStateToJSONTyped,
} from './DashboardAgentState';
import type { CustomerSupportAgentState } from './CustomerSupportAgentState';
import {
    CustomerSupportAgentStateFromJSON,
    CustomerSupportAgentStateFromJSONTyped,
    CustomerSupportAgentStateToJSON,
    CustomerSupportAgentStateToJSONTyped,
} from './CustomerSupportAgentState';

/**
 * Conversation-level metadata (not visible to users/LLM).
 * @export
 * @interface ConversationMetadata
 */
export interface ConversationMetadata {
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadata
     */
    selectedAgent?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationMetadata
     */
    usedAgents?: Array<string>;
    /**
     * 
     * @type {CustomerSupportAgentState}
     * @memberof ConversationMetadata
     */
    customerSupportAgentState?: CustomerSupportAgentState | null;
    /**
     * 
     * @type {DashboardAgentState}
     * @memberof ConversationMetadata
     */
    dashboardAgentState?: DashboardAgentState | null;
}

/**
 * Check if a given object implements the ConversationMetadata interface.
 */
export function instanceOfConversationMetadata(value: object): value is ConversationMetadata {
    return true;
}

export function ConversationMetadataFromJSON(json: any): ConversationMetadata {
    return ConversationMetadataFromJSONTyped(json, false);
}

export function ConversationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'selectedAgent': json['selected_agent'] == null ? undefined : json['selected_agent'],
        'usedAgents': json['used_agents'] == null ? undefined : json['used_agents'],
        'customerSupportAgentState': json['customer_support_agent_state'] == null ? undefined : CustomerSupportAgentStateFromJSON(json['customer_support_agent_state']),
        'dashboardAgentState': json['dashboard_agent_state'] == null ? undefined : DashboardAgentStateFromJSON(json['dashboard_agent_state']),
    };
}

export function ConversationMetadataToJSON(json: any): ConversationMetadata {
    return ConversationMetadataToJSONTyped(json, false);
}

export function ConversationMetadataToJSONTyped(value?: ConversationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selected_agent': value['selectedAgent'],
        'used_agents': value['usedAgents'],
        'customer_support_agent_state': CustomerSupportAgentStateToJSON(value['customerSupportAgentState']),
        'dashboard_agent_state': DashboardAgentStateToJSON(value['dashboardAgentState']),
    };
}

